module.exports = __webpack_public_path__ + "img/t8.5d470357.png";